/*###########################################################################
// Tooltips
//#########################################################################*/

import tippy from 'tippy.js'

let tippyInstances = []

const tooltips = {
  config: {
    tooltip: '.tooltip'
  },

  elements: {},

  init() {
    const self = this

		// For re-initialisation, destroy any existing tippy instances to prevent duplicate instances
		//
		if (tippyInstances.length) {
			tippyInstances.forEach(instance => instance.destroy())
			tippyInstances = []
		}

    self.elements.tooltips = document.querySelectorAll(self.config.tooltip)
    if (self.elements.tooltips !== null) {
      for (let i = 0; i < self.elements.tooltips.length; i++) {
        const tooltip = self.elements.tooltips[i]

        self.handleTooltip(tooltip)
      }
    }
  },

  handleTooltip(tooltip) {
    let placement = 'bottom'
    if (tooltip.hasAttribute('data-tooltip-placement') && tooltip.getAttribute('data-tooltip-placement') !== '') {
      placement = tooltip.getAttribute('data-tooltip-placement')
    }

		const tippyInstance = tippy(tooltip, {
			content: tooltip.getAttribute('data-tooltip-content') || '',
      placement: placement,
			appendTo: tooltip
    })
    tippyInstances.push(tippyInstance)
  }
}

if (document.readyState === 'complete') {
	tooltips.init()

	if (typeof htmx !== 'undefined') {
    htmx.on('htmx:afterSwap', function (event) {
      tooltips.init()
    })
  }

	window.addEventListener('cardProductColourUpdate', () => {
		setTimeout(() => {
			tooltips.init()
		}, 250)
	})
} else {
	window.addEventListener('load', () => {
		tooltips.init()
	})

  if (typeof htmx !== 'undefined') {
    htmx.on('htmx:afterSwap', function (event) {
      tooltips.init()
    })
  }

	window.addEventListener('cardProductColourUpdate', () => {
		setTimeout(() => {
			tooltips.init()
		}, 250)
	})
}
